interface VisitorApprovalPendingBadgeProps {
  count: number;
  isError?: boolean;
}

const VisitorApprovalPendingBadge = ({ count, isError }: VisitorApprovalPendingBadgeProps) => {
  if (isError) {
    return <span className="visitor-approval-pending-badge">-</span>;
  }
  if (!count || count <= 0) {
    return null;
  }
  const label = count > 99 ? "99+" : String(count);
  return <span className="visitor-approval-pending-badge">{label}</span>;
};

export default VisitorApprovalPendingBadge;
